__turbopack_context__.v({
  "className": "poppins_43d673f5-module__cRHera__className",
});
